import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower, capitalizeIfLower } from '@btime/helpers'
import { compose, path } from 'ramda'
import React from 'react'

import { SmallText, Text } from '../../../components/presentation/Text'
import DataTable from '../../../packages/kiti/components/table/DataTable'
import PlacePresenter from '../../../containers/places/PlacePresenter'
import Scroll from '../../../components/helpers/Scroll'
import { useCurrentModal } from '../../../components/modals/ModalsContext'

const DuplicateServiceOrdersList = () => {
  const { data } = useCurrentModal()

  const columns = [
    {
      label: `Questionário`,
      dataIndex: 'checklist',
      flex: 4,
      render: (value, record) => (
        <>
          <Text strong color={COLORS.dark2} breakWord>
            {compose(capitalizeIfLower, path(['checklist', 'name']))(record)}
          </Text>
        </>
      )
    },

    {
      label: 'Local/Pessoa',
      dataIndex: 'place',
      flex: 4,
      render: (value, record) => <PlacePresenter place={value} size="small" color={COLORS.dark3} hideIcon breakWord />
    }
  ]

  return (
    <Scroll maxHeight={400}>
      <DataTable rowKey="id" columns={columns} data={data?.duplicateInputs} inPanel size="medium" />
    </Scroll>
  )
}

export default DuplicateServiceOrdersList
